import { render, staticRenderFns } from "./template-selection.vue?vue&type=template&id=e56cd16e&scoped=true"
import script from "./template-selection.vue?vue&type=script&lang=js"
export * from "./template-selection.vue?vue&type=script&lang=js"
import style0 from "./template-selection.vue?vue&type=style&index=0&id=e56cd16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56cd16e",
  null
  
)

export default component.exports